import {Component, Input} from '@angular/core';

@Component({
  selector: 'field-time-readonly',
  templateUrl: 'field-time-readonly.component.html',
  styleUrls: ['field-time-readonly.component.scss']
})
export class FieldTimeReadonlyComponent {
  @Input() field: any;

  constructor() {
  }

  ngOnInit() {
  }

  get value() {
    return this.field.value?.data || [];
  }

}
